import {SET_SERVICES , ACTIVE_SERVICE} from "@/core/store/modules/services/constants";
export default {
    [SET_SERVICES](state, data){
        state.service=data.services
        state.buy_service=data.buy_service
    },
    [ACTIVE_SERVICE](state, data){
        state.activeService=data
    }
}